import { ResolvedError } from '@wix/error-handler-types';

type PanoramaErrorTags = Record<
  string,
  string | number | boolean | null | undefined
>;

/**
 * Errors thrown by the app's HTTP client are `ResolvedError` plain objects (from
 * `getResolvedError`), not `Error` instances — so `String(e)` degrades to
 * "[object Object]". This extracts the resolved message and known error metadata
 * so panorama logs stay readable and groupable.
 */
export const toPanoramaError = (
  e: unknown,
  tags: PanoramaErrorTags = {},
): { error: Error; tags: PanoramaErrorTags } => {
  const resolved = e as Partial<ResolvedError>;
  const error =
    e instanceof Error ? e : new Error(resolved?.message ?? String(e));

  return {
    error,
    tags: {
      ...tags,
      ...(resolved?.applicationError?.code
        ? { appErrorCode: resolved.applicationError.code }
        : {}),
      ...(resolved?.httpError?.response?.status
        ? { httpStatus: String(resolved.httpError.response.status) }
        : {}),
      ...(resolved?.requestId ? { requestId: resolved.requestId } : {}),
    },
  };
};
